import escape from 'lodash.escape';

export const alertDismiss = (alertWrapperSelector = '#alert-box') => {
    const alertWrapperEl = document.querySelector(alertWrapperSelector);
    alertWrapperEl.innerHTML = ''; //reset alert
};

export const alert = (
    type,
    message,
    escapeMessage = true,
    alertWrapperSelector = '#alert-box',
    resetAlert = true,
    showClose = true
) => {
    const alertWrapperEl = document.querySelector(alertWrapperSelector);
    if (resetAlert) {
        alertDismiss(alertWrapperSelector);
    }

    const html = `
        <div class="alert alert-${type} alert-dismissible alert-flash fade show rounded-2 d-flex flex-row text-start" role="alert">
           ${escapeMessage ? `<span>${escape(message)}</span>` : message}
           ${showClose ? '<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>' : ''}
        </div>
    `;
    alertWrapperEl.innerHTML = html;
};

export default alert;
